/* KiekkoKingi filter module: shared route shell. Generated from kk-native-filters.js. */
(function () {
  var keepFilterModalOpen = false;
  var manualCloseUntil = 0;
  var reopenTimer = null;
  var stateSyncTimer = null;
  var filterModalScrollTop = 0;
  var hiddenFloatingWidgets = [];
  var floatingWidgetObserver = null;
  var widgetHiddenMarker = 'route-shell';
  var nativeFilterDialogId = 'kk-productgrid-filter-dialog';
  var nativeFilterOpener = null;
  var nativeFilterModalWasOpen = false;
  var nativeFilterFocusTimer = null;
  var nativeFilterRefocusUntil = 0;
  var nativeSearchFocusReturnUntil = 0;
  var nativeFilterDefaultModalLabel = null;

  function isMobile() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function closestElement(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function isSearchRoute() {
    return Boolean(document.body && document.body.classList.contains('template-search'));
  }

  function getFilterRouteRoot() {
    if (!document.body) {
      return null;
    }

    if (document.body.classList.contains('template-search')) {
      return document.querySelector('.search--section');
    }

    if (document.body.classList.contains('template-collection')) {
      return document.querySelector('.collection--section');
    }

    return null;
  }

  function getModalContainer() {
    return document.querySelector('[data-modal-container].modal--productgrid-filters');
  }

  function getFilterTrigger() {
    var routeRoot = getFilterRouteRoot();

    return routeRoot ? routeRoot.querySelector('[data-productgrid-trigger-filters]') : null;
  }

  function isNativeFilterRoute() {
    return Boolean(document.querySelector(
      'script[src*="kk-native-filter-search.js"], script[src*="kk-native-filter-collection.js"]'
    ));
  }

  function getNativeFilterDialogLabel(modal, trigger) {
    var heading = modal ? modal.querySelector('.productgrid--sidebar-title') : null;
    var label = heading ? heading.textContent.trim() : '';
    var triggerText;

    if (label) {
      return label;
    }

    triggerText = trigger ? trigger.querySelector('.utils-filter-text') : null;
    label = triggerText ? triggerText.textContent.trim() : '';

    return label || (trigger ? trigger.getAttribute('aria-label') : '') || 'Filters';
  }

  function focusNativeFilterOpener() {
    var trigger;

    window.clearTimeout(nativeFilterFocusTimer);
    nativeFilterFocusTimer = null;

    if (
      !isNativeFilterRoute() ||
      !isMobile() ||
      (document.body && document.body.classList.contains('modal-visible'))
    ) {
      return;
    }

    // Native search/collection AJAX can replace the original control. Prefer
    // the current route control and use the captured opener only as fallback.
    trigger = getFilterTrigger();
    if (!trigger && nativeFilterOpener && nativeFilterOpener.isConnected) {
      trigger = nativeFilterOpener;
    }

    if (!trigger || typeof trigger.focus !== 'function') {
      return;
    }

    try {
      trigger.focus({ preventScroll: true });
    } catch (error) {
      trigger.focus();
    }

    nativeFilterOpener = trigger;
  }

  function queueNativeFilterFocusReturn(delay) {
    window.clearTimeout(nativeFilterFocusTimer);
    nativeFilterFocusTimer = window.setTimeout(function () {
      nativeFilterFocusTimer = null;

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(focusNativeFilterOpener);
      } else {
        focusNativeFilterOpener();
      }
    }, delay || 0);
  }

  function focusNativeFilterDialog(modal) {
    var focusTarget;

    if (!modal || modal.contains(document.activeElement)) {
      return;
    }

    focusTarget = modal.querySelector('[data-modal-close]') || modal;

    if (typeof focusTarget.focus !== 'function') {
      return;
    }

    try {
      focusTarget.focus({ preventScroll: true });
    } catch (error) {
      focusTarget.focus();
    }
  }

  function syncNativeFilterDialogA11y() {
    var modal;
    var trigger;
    var modalIsOpen;

    if (!isNativeFilterRoute()) {
      return;
    }

    modal = document.querySelector('[data-modal-container]');
    trigger = getFilterTrigger();
    modalIsOpen = isFilterModalOpen();

    if (modal) {
      modal.id = nativeFilterDialogId;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('tabindex', '-1');
    }

    if (trigger) {
      trigger.setAttribute('aria-controls', nativeFilterDialogId);
      trigger.setAttribute('aria-expanded', modalIsOpen ? 'true' : 'false');
    }

    if (modalIsOpen && modal) {
      nativeFilterRefocusUntil = 0;

      if (nativeFilterDefaultModalLabel === null) {
        nativeFilterDefaultModalLabel = modal.getAttribute('aria-label') || '';
      }

      modal.setAttribute('aria-label', getNativeFilterDialogLabel(modal, trigger));
      focusNativeFilterDialog(modal);
      nativeFilterModalWasOpen = true;
      return;
    }

    if (modal) {
      if (nativeFilterDefaultModalLabel) {
        modal.setAttribute('aria-label', nativeFilterDefaultModalLabel);
      } else if (nativeFilterDefaultModalLabel !== null) {
        modal.removeAttribute('aria-label');
      }
    }

    if (nativeFilterModalWasOpen) {
      nativeFilterModalWasOpen = false;

      // Native collection live-facet refreshes briefly close the Superstore
      // modal before the route shell reopens it. That is not a customer close:
      // keep focus inside the perceived dialog lifecycle instead of bouncing
      // it to the opener for the short refresh gap.
      if (!isSearchRoute() && shouldReopenFilterModal()) {
        nativeFilterRefocusUntil = 0;
        return;
      }

      nativeFilterRefocusUntil = Date.now() + 10000;
      queueNativeFilterFocusReturn(0);
    }
  }

  function isFilterModalOpen() {
    var modal = getModalContainer();

    return Boolean(
      modal &&
      modal.classList.contains('modal--productgrid-filters') &&
      document.body.classList.contains('modal-visible')
    );
  }

  function getFloatingWidgetElements(scope) {
    var selectors = [
      '.chat-app',
      '.chat-toggle',
      '#ShopifyChat',
      '[id^="ShopifyChat"]',
      '[id*="gorgias-chat" i]',
      '[class*="gorgias-chat" i]',
      '#intercom-container',
      '.intercom-lightweight-app',
      '[class*="intercom-launcher" i]',
      '#crisp-chatbox',
      '.crisp-client',
      'iframe[src*="chat" i]',
      'iframe[src*="gorgias" i]',
      'iframe[src*="intercom" i]',
      'iframe[src*="crisp" i]',
      '#Avada-FAQ_Widget',
      '#smile-ui-lite-container',
      '#smile-ui-container',
      '#smile-ui-lite-launcher-frame-container'
    ];
    var elements = [];
    var modal = getModalContainer();

    function addElement(element) {
      if (
        !element ||
        element === document.documentElement ||
        element === document.body ||
        (modal && (element === modal || modal.contains(element))) ||
        elements.indexOf(element) !== -1
      ) {
        return;
      }

      elements.push(element);
    }

    function collectFromRoot(root) {
      if (!root || !root.querySelectorAll) {
        return;
      }

      selectors.forEach(function (selector) {
        try {
          if (root.matches && root.matches(selector)) {
            addElement(root);
          }
          root.querySelectorAll(selector).forEach(addElement);
        } catch (error) {
          // Ignore unsupported third-party selector shapes in older browsers.
        }
      });

      root.querySelectorAll('*').forEach(function (element) {
        if (element.shadowRoot) {
          collectFromRoot(element.shadowRoot);
        }
      });
    }

    collectFromRoot(scope || document);

    return elements;
  }

  function setFloatingWidgetsHidden(hidden, scope) {
    var entries = hidden ? getFloatingWidgetElements(scope) : hiddenFloatingWidgets.slice();

    entries.forEach(function (entry) {
      var element = hidden ? entry : entry.element;
      var existingEntry;

      if (!element || !element.style) {
        return;
      }

      if (hidden) {
        existingEntry = hiddenFloatingWidgets.find(function (hiddenEntry) {
          return hiddenEntry.element === element;
        });

        if (!existingEntry) {
          // Do not take ownership of an element hidden by another controller.
          if (element.hasAttribute('data-kk-filter-widget-hidden')) {
            return;
          }

          existingEntry = {
            element: element,
            display: element.style.getPropertyValue('display'),
            displayPriority: element.style.getPropertyPriority('display'),
            visibility: element.style.getPropertyValue('visibility'),
            visibilityPriority: element.style.getPropertyPriority('visibility'),
            pointerEvents: element.style.getPropertyValue('pointer-events'),
            pointerEventsPriority: element.style.getPropertyPriority('pointer-events')
          };
          hiddenFloatingWidgets.push(existingEntry);
          element.setAttribute('data-kk-filter-widget-hidden', widgetHiddenMarker);
        }

        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
        return;
      }

      element.style.setProperty(
        'display',
        entry.display,
        entry.displayPriority
      );
      element.style.setProperty(
        'visibility',
        entry.visibility,
        entry.visibilityPriority
      );
      element.style.setProperty(
        'pointer-events',
        entry.pointerEvents,
        entry.pointerEventsPriority
      );

      if (element.getAttribute('data-kk-filter-widget-hidden') === widgetHiddenMarker) {
        element.removeAttribute('data-kk-filter-widget-hidden');
      }
    });

    if (!hidden) {
      hiddenFloatingWidgets = [];
    }
  }

  function syncFloatingWidgetObserver(hidden) {
    if (!window.MutationObserver || !document.body) {
      return;
    }

    if (!hidden) {
      if (floatingWidgetObserver) {
        floatingWidgetObserver.disconnect();
        floatingWidgetObserver = null;
      }
      return;
    }

    if (floatingWidgetObserver) {
      return;
    }

    // App launchers are injected as direct body children. Observe only that
    // boundary while the dialog is open instead of watching every mutation in
    // the document (which multiplied headless facet and Langify work).
    floatingWidgetObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) {
            setFloatingWidgetsHidden(true, node);
          }
        });
      });
    });
    floatingWidgetObserver.observe(document.body, { childList: true });
  }

  function syncFilterModalWidgetVisibility() {
    var hidden = isMobile() && isFilterModalOpen();
    var wasHidden;

    if (!document.body) {
      return;
    }

    wasHidden = document.body.classList.contains('kk-filter-modal-visible');
    document.body.classList.toggle(
      'kk-filter-modal-visible',
      hidden
    );
    if (hidden) {
      if (!wasHidden) {
        setFloatingWidgetsHidden(true);
      }
      syncFloatingWidgetObserver(true);
    } else if (hiddenFloatingWidgets.length) {
      syncFloatingWidgetObserver(false);
      setFloatingWidgetsHidden(false);
    } else {
      syncFloatingWidgetObserver(false);
    }

    syncNativeFilterDialogA11y();
  }

  function isNativeFilterTarget(target) {
    var modal = getModalContainer();
    var filterTarget = closestElement(
      target,
      '[data-filter-checkbox], [data-filter-range], [data-filter-remove], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    );

    return Boolean(modal && filterTarget && modal.contains(filterTarget));
  }

  function rememberFilterModalScroll() {
    var modal = getModalContainer();

    if (modal) {
      filterModalScrollTop = modal.scrollTop;
    }
  }

  function restoreFilterModalScroll() {
    var modal = getModalContainer();

    if (modal && document.body.classList.contains('modal-visible')) {
      modal.scrollTop = filterModalScrollTop;
    }
  }

  function markFilterModalDirty(target) {
    if (isMobile() && isFilterModalOpen() && isNativeFilterTarget(target)) {
      rememberFilterModalScroll();
      keepFilterModalOpen = true;
      manualCloseUntil = 0;
    }
  }

  function resetReopenState(blockManualReopen) {
    keepFilterModalOpen = false;
    window.clearTimeout(reopenTimer);
    reopenTimer = null;
    manualCloseUntil = blockManualReopen ? Date.now() + 10000 : 0;
  }

  function queueFilterModalStateSync(delay) {
    if (stateSyncTimer !== null) {
      return;
    }

    stateSyncTimer = window.setTimeout(function () {
      stateSyncTimer = null;
      syncFilterModalWidgetVisibility();
    }, delay || 0);
  }

  function markManualClose() {
    resetReopenState(true);
    syncFilterModalWidgetVisibility();

    // This runs during the capture phase, before Superstore removes its
    // modal-visible class. Recheck after the delegated modal handler has
    // completed so the KiekkoKingi widget-hiding class cannot remain stale.
    queueFilterModalStateSync(0);
    window.setTimeout(syncFilterModalWidgetVisibility, 80);
  }

  function shouldReopenFilterModal() {
    return Boolean(
      keepFilterModalOpen &&
      isMobile() &&
      Date.now() > manualCloseUntil &&
      !document.body.classList.contains('modal-visible') &&
      getFilterTrigger()
    );
  }

  function reopenFilterModal() {
    var trigger;

    window.clearTimeout(reopenTimer);
    reopenTimer = null;

    if (!shouldReopenFilterModal()) {
      return;
    }

    trigger = getFilterTrigger();

    if (trigger) {
      trigger.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));

      // A single reopen attempt is enough. Leaving this flag set lets an
      // unrelated later DOM mutation reopen a filter the customer closed.
      resetReopenState(false);
      window.setTimeout(restoreFilterModalScroll, 120);
      window.setTimeout(syncFilterModalWidgetVisibility, 130);
    }
  }

  function queueReopenFilterModal() {
    if (!keepFilterModalOpen && !isFilterModalOpen() && !hiddenFloatingWidgets.length) {
      return;
    }

    queueFilterModalStateSync(0);

    if (!keepFilterModalOpen || reopenTimer !== null) {
      return;
    }

    reopenTimer = window.setTimeout(function () {
      reopenFilterModal();
    }, 80);
  }

  function handleObservedModalStateChange() {
    // Search filters are applied after the mobile modal closes. The close is
    // therefore final for this interaction and must not be undone by an AJAX
    // result mutation that happens a moment later.
    if (isSearchRoute() && !isFilterModalOpen()) {
      resetReopenState(false);
    }

    syncFilterModalWidgetVisibility();

    if (!isSearchRoute()) {
      queueReopenFilterModal();
    }
  }

  function handleSearchResultsReplacement(mutations) {
    var replaced = mutations.some(function (mutation) {
      return mutation.type === 'childList' && (
        mutation.addedNodes.length || mutation.removedNodes.length
      );
    });

    if (!replaced) {
      return;
    }

    // Native search replaces this container after its AJAX response. Clear
    // the one-shot keep/reopen state before global DOM observers see the new
    // cards, then synchronise again after Superstore has completed cleanup.
    resetReopenState(false);
    syncFilterModalWidgetVisibility();
    queueFilterModalStateSync(0);
    window.setTimeout(syncFilterModalWidgetVisibility, 100);
  }

  document.addEventListener('change', function (event) {
    markFilterModalDirty(event.target);
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab') {
      markFilterModalDirty(event.target);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var modalInner = closestElement(event.target, '.modal--productgrid-filters [data-modal-inner]');
    var filterTrigger = closestElement(event.target, '[data-productgrid-trigger-filters]');
    var filterResultsButton = closestElement(
      event.target,
      '.modal--productgrid-filters [data-kk-filter-results-button]'
    );
    var modalClose = closestElement(event.target, '.modal--productgrid-filters [data-modal-close]');

    if (isNativeFilterRoute() && isMobile() && filterTrigger) {
      nativeFilterOpener = filterTrigger;
      nativeFilterRefocusUntil = 0;
      nativeSearchFocusReturnUntil = 0;
      filterTrigger.setAttribute('aria-controls', nativeFilterDialogId);
      filterTrigger.setAttribute('aria-expanded', 'true');
    }

    if (!isMobile() || !isFilterModalOpen()) {
      return;
    }

    if (filterResultsButton && isNativeFilterRoute() && isSearchRoute()) {
      // Search replaces the focused opener as part of its deferred AJAX apply.
      // Authorise one matching native-search completion to focus the fresh
      // route control; the deadline prevents a later sort/pagination response
      // from consuming stale intent when the apply request fails.
      nativeFilterOpener = getFilterTrigger() || nativeFilterOpener;
      nativeSearchFocusReturnUntil = Date.now() + 10000;
    } else if (modalClose || !modalInner) {
      nativeSearchFocusReturnUntil = 0;
    }

    if (filterResultsButton || modalClose || !modalInner) {
      markManualClose();
      return;
    }

    markFilterModalDirty(event.target);
    syncFilterModalWidgetVisibility();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isFilterModalOpen()) {
      nativeSearchFocusReturnUntil = 0;
      markManualClose();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    var currentTrigger;
    var modal;
    var target = event.target;

    if (
      !nativeSearchFocusReturnUntil ||
      !target ||
      target === document.body ||
      target === document.documentElement ||
      !target.isConnected
    ) {
      return;
    }

    currentTrigger = getFilterTrigger();
    modal = getModalContainer();

    if (
      target === nativeFilterOpener ||
      target === currentTrigger ||
      (modal && modal.contains(target))
    ) {
      return;
    }

    // A deliberate newer focus owner cancels the pending apply handoff. If
    // that control is later replaced by another AJAX action, the stale search
    // intent must not redirect the resulting BODY focus back to Filters.
    nativeSearchFocusReturnUntil = 0;
    nativeFilterRefocusUntil = 0;
  }, true);

  window.addEventListener('resize', function () {
    if (!isMobile()) {
      resetReopenState(false);
      nativeSearchFocusReturnUntil = 0;
    }

    syncFilterModalWidgetVisibility();
  });

  document.addEventListener('kk:collection-search-complete', function (event) {
    var activeElement;
    var explicitSearchFocusReturn = Boolean(
      event &&
      event.detail &&
      event.detail.source === 'native-search' &&
      Date.now() <= nativeSearchFocusReturnUntil
    );
    var modal;

    // Native collection AJAX is the exact lifecycle boundary that previously
    // depended on a document-wide subtree observer. Reopen/synchronise once
    // after the replacement has completed; headless and search renders do not
    // enter this branch.
    if (event && event.detail && event.detail.source === 'native-collection') {
      queueReopenFilterModal();
      queueFilterModalStateSync(0);
    }

    // A completion signal is one-shot even when a newer focus owner prevents
    // recovery. This keeps later native-search requests from stealing focus.
    if (event && event.detail && event.detail.source === 'native-search') {
      nativeSearchFocusReturnUntil = 0;
    }

    if (
      !isFilterModalOpen() &&
      (explicitSearchFocusReturn || Date.now() <= nativeFilterRefocusUntil)
    ) {
      nativeFilterRefocusUntil = 0;

      // The completion can arrive several seconds after the dialog closed.
      // Respect any newer focus owner (including another modal) and only
      // recover focus when AJAX replacement left it on the document itself or
      // on the now-hidden shared modal shell.
      if (document.body && document.body.classList.contains('modal-visible')) {
        return;
      }

      activeElement = document.activeElement;
      modal = document.querySelector('[data-modal-container]');

      if (
        activeElement &&
        activeElement !== document.body &&
        activeElement !== document.documentElement &&
        activeElement.isConnected &&
        !(modal && modal.contains(activeElement))
      ) {
        return;
      }

      queueNativeFilterFocusReturn(0);
    }
  });

  document.addEventListener('shopify:section:load', function () {
    // Theme Editor section replacement creates a fresh trigger. Reapply its
    // closed/open control relationship without requiring a click or resize.
    nativeSearchFocusReturnUntil = 0;
    queueFilterModalStateSync(0);
  });

  window.addEventListener('pagehide', function () {
    nativeSearchFocusReturnUntil = 0;
    syncFloatingWidgetObserver(false);
    if (hiddenFloatingWidgets.length) setFloatingWidgetsHidden(false);
    if (document.body) document.body.classList.remove('kk-filter-modal-visible');
  });

  window.addEventListener('pageshow', function () {
    queueFilterModalStateSync(0);
  });

  window.addEventListener('popstate', function () {
    nativeSearchFocusReturnUntil = 0;
  });

  if (window.MutationObserver) {
    var modalShell = document.querySelector('[data-modal-container]');
    var searchResults = isSearchRoute() ?
      document.querySelector('.search--section [data-results-container]') :
      null;

    new MutationObserver(handleObservedModalStateChange).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (modalShell) {
      new MutationObserver(handleObservedModalStateChange).observe(modalShell, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (searchResults) {
      new MutationObserver(handleSearchResultsReplacement).observe(searchResults, {
        childList: true
      });
    }

  }

  syncFilterModalWidgetVisibility();
}());

(function () {
  function decodeScopedSearchValue(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
    } catch (error) {
      return String(value || '').replace(/\+/g, ' ');
    }
  }

  function trimScopedSearchValue(value) {
    return decodeScopedSearchValue(value).trim();
  }

  function escapeScopedSearchValue(value) {
    return trimScopedSearchValue(value)
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/([:()])/g, '\\$1');
  }

  function unescapeScopedSearchValue(value) {
    return String(value || '')
      .replace(/&amp;quot;/g, '"')
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/\\(.)/g, '$1');
  }

  function buildScopedSearchQuery(value) {
    return trimScopedSearchValue(value);
  }

  function extractScopedSearchTerm(value) {
    var query = unescapeScopedSearchValue(trimScopedSearchValue(value));
    var matches = query.match(/^title:"((?:\\.|[^"])*)" OR vendor:"((?:\\.|[^"])*)"$/);

    if (matches && matches[1] === matches[2]) {
      return unescapeScopedSearchValue(matches[1]);
    }

    if (query.indexOf('title:') === 0 && query.indexOf(' OR vendor:') !== -1) {
      return query
        .split('title:').pop()
        .split(' OR vendor:')[0]
        .replace(/^"+|"+$/g, '');
    }

    return query;
  }

  window.kkScopedSearch = {
    buildQuery: buildScopedSearchQuery,
    decodeValue: decodeScopedSearchValue,
    extractTerm: extractScopedSearchTerm,
    trimValue: trimScopedSearchValue
  };
}());

(function () {
  function getScopedSearchHelpers() {
    return window.kkScopedSearch || null;
  }

  function syncScopedSearchForm(form) {
    var helpers = getScopedSearchHelpers();
    var visibleInput = form && form.querySelector('[data-kk-search-visible-input]');
    var queryInput = form && form.querySelector('[data-kk-search-query-input]');

    if (!helpers || !visibleInput || !queryInput) {
      return;
    }

    queryInput.value = helpers.buildQuery(visibleInput.value);
  }

  document.addEventListener('input', function (event) {
    var visibleInput = event.target.closest('[data-kk-search-visible-input]');

    if (!visibleInput) {
      return;
    }

    syncScopedSearchForm(visibleInput.closest('[data-live-search-form]'));
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-live-search-form]');

    if (!form) {
      return;
    }

    syncScopedSearchForm(form);
  }, true);

  function initScopedSearchForms() {
    document.querySelectorAll('[data-live-search-form]').forEach(syncScopedSearchForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScopedSearchForms);
  } else {
    initScopedSearchForms();
  }
}());

(function () {
  var NAVIGATING_ATTR = 'data-kk-live-search-navigating';
  var SUBMITTING_ATTR = 'data-kk-live-search-submitting';
  var TOUCH_MOVE_TOLERANCE = 12;
  var touchCandidate = null;

  function isMobileViewport() {
    if (window.matchMedia) {
      return window.matchMedia('(max-width: 859px)').matches;
    }

    return window.innerWidth <= 859;
  }

  function findLiveSearchResultLink(target) {
    var link = target && target.closest ? target.closest('a[href]') : null;

    if (!link || !link.closest('[data-live-search]')) {
      return null;
    }

    if (!link.closest('[data-live-search-results], [data-live-search-flydown]')) {
      return null;
    }

    if (!link.closest('.kk-predictive-search')) {
      return null;
    }

    return link;
  }

  function findLiveSearchContinueButton(target) {
    var button = target && target.closest ? target.closest('button.kk-predictive-search__continue') : null;

    if (!button || !button.closest('[data-live-search]')) {
      return null;
    }

    if (!button.closest('[data-live-search-results], [data-live-search-flydown]')) {
      return null;
    }

    if (!button.closest('.kk-predictive-search')) {
      return null;
    }

    return button;
  }

  function canNavigateLiveSearchLink(link, event) {
    var href;

    if (!link || !isMobileViewport()) {
      return false;
    }

    href = link.getAttribute('href');

    if (!href || href === '#' || link.hasAttribute('download')) {
      return false;
    }

    if (link.target && link.target !== '_self') {
      return false;
    }

    if (event && event.type === 'click') {
      if (event.button && event.button !== 0) {
        return false;
      }

      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return false;
      }
    }

    return true;
  }

  function canSubmitLiveSearchContinue(button) {
    if (!button || !isMobileViewport()) {
      return false;
    }

    if (button.disabled || button.classList.contains('kk-predictive-search__continue--pending')) {
      return false;
    }

    return true;
  }

  function getLiveSearchResultsUrl(form) {
    var action = form && form.getAttribute('action') ? form.getAttribute('action') : '/search';
    var url = new URL(action, window.location.origin);
    var params = new URLSearchParams(form ? new FormData(form) : undefined);
    var visibleInput = form && form.querySelector('[data-kk-search-visible-input]');
    var queryInput = form && form.querySelector('[data-kk-search-query-input]');
    var rawQuery = visibleInput ? visibleInput.value : params.get('q');
    var query = window.kkScopedSearch && typeof window.kkScopedSearch.buildQuery === 'function' ?
      window.kkScopedSearch.buildQuery(rawQuery || '') :
      (rawQuery || '');

    if (queryInput) {
      queryInput.value = query;
    }

    params.set('q', query);

    if (!params.get('type')) {
      params.set('type', 'product');
    }

    url.search = params.toString();

    return url.toString();
  }

  function openLiveSearchLink(link, event) {
    if (!canNavigateLiveSearchLink(link, event)) {
      return;
    }

    if (link.getAttribute(NAVIGATING_ATTR) === 'true') {
      return;
    }

    link.setAttribute(NAVIGATING_ATTR, 'true');

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    window.location.assign(link.href);
  }

  function openLiveSearchResults(button, event) {
    var form;

    if (!canSubmitLiveSearchContinue(button)) {
      return;
    }

    form = button.form || button.closest('[data-live-search-form]');

    if (!form || button.getAttribute(SUBMITTING_ATTR) === 'true') {
      return;
    }

    button.setAttribute(SUBMITTING_ATTR, 'true');

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    window.location.assign(getLiveSearchResultsUrl(form));
  }

  document.addEventListener('touchstart', function (event) {
    var link = findLiveSearchResultLink(event.target);
    var continueButton = findLiveSearchContinueButton(event.target);
    var touch = event.touches && event.touches[0];

    if (!touch) {
      touchCandidate = null;
      return;
    }

    if (!canNavigateLiveSearchLink(link, event) && !canSubmitLiveSearchContinue(continueButton)) {
      touchCandidate = null;
      return;
    }

    touchCandidate = {
      action: link ? 'link' : 'continue',
      target: link || continueButton,
      x: touch.clientX,
      y: touch.clientY
    };
  }, true);

  document.addEventListener('touchend', function (event) {
    var target;
    var touch;
    var moved;

    if (!touchCandidate) {
      return;
    }

    target = touchCandidate.action === 'link' ?
      findLiveSearchResultLink(event.target) :
      findLiveSearchContinueButton(event.target);
    touch = event.changedTouches && event.changedTouches[0];

    moved = touch ? (
      Math.abs(touch.clientX - touchCandidate.x) > TOUCH_MOVE_TOLERANCE ||
      Math.abs(touch.clientY - touchCandidate.y) > TOUCH_MOVE_TOLERANCE
    ) : false;

    if (target && target === touchCandidate.target && !moved) {
      if (touchCandidate.action === 'link') {
        openLiveSearchLink(target, event);
      } else {
        openLiveSearchResults(target, event);
      }
    }

    touchCandidate = null;
  }, true);

  document.addEventListener('touchcancel', function () {
    touchCandidate = null;
  }, true);

  document.addEventListener('click', function (event) {
    openLiveSearchResults(findLiveSearchContinueButton(event.target), event);
    openLiveSearchLink(findLiveSearchResultLink(event.target), event);
  }, true);
}());
